<template>
  <div>
    <!-- 分组 -->
    <el-submenu :key="menu.id"
                v-if="menu.children && menu.children.length" 
                :index="menu.jumpUrl">
      <span slot="title">{{menu.name}}</span>
      <sub-menu v-for="child in menu.children"
                :key="child.id"
                :menu="child">
      </sub-menu>
    </el-submenu>
    <!-- 单个 -->
    <el-menu-item :key="menu.id"
                    v-else
                  :index="menu.jumpUrl">
      <span slot="title">{{menu.name}}</span>
    </el-menu-item>
  </div>
</template>

<script>
import SubMenu from './sub-menu'
export default {
  name: 'sub-menu',
  data () {
    return {}
  },
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  components: {
    SubMenu
  },
  computed: {
  },
  created () { },
  methods: {
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// src/views/layout/sub-menu.vue